const BASE_MISSION_MASCOT_MINI_CLASS =
  "pointer-events-none absolute object-contain"

export function getMissionMascotMiniClassName(mascotMini: string): string {
  if (mascotMini.includes("turtle")) {
    return `${BASE_MISSION_MASCOT_MINI_CLASS} bottom-[16px] right-[12px] max-h-[68px] max-w-[94px]`
  }

  if (mascotMini.includes("beluga")) {
    return `${BASE_MISSION_MASCOT_MINI_CLASS} bottom-[5px] right-[4px] max-h-[76px] max-w-[104px]`
  }

  return `${BASE_MISSION_MASCOT_MINI_CLASS} bottom-[9px] right-[12px] max-h-[68px] max-w-[94px]`
}
